export const sidebarSections = {
    loyalty: 'loyaltyTier',
    menu: 'accountLinks',
    showcase: 'showcase',
    welcome: 'profileWelcome'
};
